import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { IAuthStore } from "@/templates/authManagement/authStore/types";
import { IAuthStepEnum } from "@/templates/authManagement/authStore/types";

const initialState = {
  loginSide: true,
  whiteLogo: true,
  step: IAuthStepEnum.LOGIN,
  finalStep: IAuthStepEnum.LOGIN,
  loginMetaData: {
    userName: "",
    password: "",
  },
  forgetPasswordMeteData: {
    userName: "",
    otp: "",
  },
};

export const useAuthStore = create<IAuthStore>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        ...initialState,
        changeType: () => {},
        setLoginSide: (state) => set({ loginSide: state }),
        setWhiteLogo: (state) => set({ whiteLogo: state }),
        setStep: (state) => set({ step: state }),
        setFinalStep: (state) => set({ finalStep: state }),
        setChangeType: (func) => {
          set({ changeType: func });
        },
        setLoginMetaData: (data) => set({ loginMetaData: data }),
        setForgetPasswordMeteData: (data) =>
          set({ forgetPasswordMeteData: data }),
        resetState: () => {
          set({ ...initialState });
        },
      }),
      {
        enabled: !import.meta.env.PROD,
        name: "authStore",
      },
    ),
  ),
);
